
export const MuiBackdrop = {
    styleOverrides: {
        root: {
            opacity: '0.2 !important',
            position: 'absolute',
            '& .MuiModal-root': {
                position: 'absolute'
            }
        }
    }
}
